module.exports = __webpack_public_path__ + "static/AngelaHe10-2b298239c3de5334ba0936246f3a3d03.webp";